import React from 'react';
import { Box } from '@mui/material';

import Sidebar from '../components/Sidebar';
import Usage from '../components/usage/Usage';

export const UsagePage = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        width: '100%',
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          height: '100vh',
          position: 'sticky',
          top: 0,
        }}
      >
        <Sidebar />
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          ml: 4,
        }}
      >
        <Usage />
      </Box>
    </Box>
  );
};

export default UsagePage;
